import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { SystemAlert } from '../../../../services/application-config.service';

@Component({
    selector: 'app-create-system-alert',
    templateUrl: './create-system-alert.component.html',
    styleUrls: ['./create-system-alert.component.scss'],
    standalone: false
})
export class CreateSystemAlertComponent implements OnInit {
    @Input() showCreateModal: boolean = false;
    @Input() savingAlert: boolean = false;
    @Output() onCreate = new EventEmitter<SystemAlert>();
    @Output() onCancel = new EventEmitter<void>();

    public alertForm: FormGroup;

    constructor(private fb: FormBuilder) { }

    ngOnInit(): void {
        this.alertForm = this.fb.group(
            {
                title: ['', Validators.required],
                message: ['', Validators.required],
                startDate: ['', Validators.required],
                endDate: ['', Validators.required]
            },
            { validators: this.dateRangeValidator } 
        );
    }

    // Custom validator to ensure startDate <= endDate
    private dateRangeValidator(group: AbstractControl): { [key: string]: boolean } | null {
        const startDate = group.get('startDate').value;
        const endDate = group.get('endDate').value;

        if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
            return { dateRangeInvalid: true }; // Validation error
        }
        return null;
    }

    public createAlert() {
        if (this.alertForm.valid) {
            this.onCreate.emit(this.alertForm.value);
        }
    }

    public cancel() {
        this.onCancel.emit();
    }
}